import { render, staticRenderFns } from "./Downloadlatest.vue?vue&type=template&id=b87286b6&scoped=true"
import script from "./Downloadlatest.vue?vue&type=script&lang=js"
export * from "./Downloadlatest.vue?vue&type=script&lang=js"
import style0 from "./Downloadlatest.vue?vue&type=style&index=0&id=b87286b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87286b6",
  null
  
)

export default component.exports